import React from 'react'

const JournalTabButton: React.FC<{
  tabName: string
  currentTab: string
  onClick: () => void
}> = ({ tabName, currentTab, onClick }) => (
  <button
    className={`cursor-pointer [border:none] py-3 px-[30px] rounded-2xl flex flex-row items-start justify-start ${
      currentTab === tabName ? 'bg-secondary-gray' : 'bg-primary-blue-90'
    }`}
    onClick={onClick}
  >
    <a
      className={`[text-decoration:none] relative text-sm font-medium font-text-md-medium1 text-left ${
        currentTab === tabName ? 'text-gray' : 'text-[#536A72]'
      }`}
    >
      {tabName.charAt(0).toUpperCase() + tabName.slice(1)}
    </a>
  </button>
)

export default JournalTabButton
